export default {
	reset: 'locations/:locationId/queuing-system-resets/created'
}
